import { getCounts } from "./helper";

// Scores
export const metaDataScoreWeights = [
  20, // MetaTitle Keyword Inclusion
  20, // MetaTitle Length
  20, // Meta TItle AND H1 Diff
  20, // Meta Desc Keyword Inclusion
  20, // Meta Desc Length
];

//   Meta Title Length Check
export const metaTitleLength = (metaTitle) => {
  const counts = getCounts(metaTitle);
  if (counts.chars < 30 || counts.chars > 70) {
    return {
      score: 0,
      percentage: 0,
      chars: counts.chars,
      words: counts.words,
    };
  }
  if (
    (counts.chars >= 30 && counts.chars <= 49) ||
    (counts.chars >= 61 && counts.chars <= 70)
  ) {
    return {
      score: 50,
      percentage: 60,
      chars: counts.chars,
      words: counts.words,
    };
  }
  if (counts.chars >= 50 && counts.chars <= 60) {
    return {
      score: 100,
      percentage: 100,
      chars: counts.chars,
      words: counts.words,
    };
  }
};

// Meta Description Length Check
export const metaDescLength = (metaDescription) => {
  const counts = getCounts(metaDescription);
  if (counts.chars < 80 || counts.chars > 180) {
    return { score: 0, chars: counts.chars, words: counts.words };
  }
  if (
    (counts.chars >= 80 && counts.chars <= 119) ||
    (counts.chars >= 156 && counts.chars <= 180)
  ) {
    return {
      score: 50,
      chars: counts.chars,
      words: counts.words,
    };
  }
  if (counts.chars >= 120 && counts.chars <= 155) {
    return { score: 100, chars: counts.chars, words: counts.words };
  }
};
